// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postGroup } from '../../services/GroupsService';
import { Group, PostGroupRequest } from '../../types/Groups';

type Result = UseMutationResult<Group, Error, PostGroupRequest>;

function usePostGroup(successCb: (group: Group) => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postGroup, {
    onSuccess: (group: Group) => {
      successCb(group);
      queryClient.invalidateQueries({ queryKey: ['groups'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostGroup;
